import BaoDialog from "../../factories/bao-dialog";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";
import WorkItemPriority from "../work-item-priority";
import WorkItemType from "../work-item-type";
import { WorkItemRelationTabNames } from "../../constants/work-item-relation-tab-names";

/**
 * ViewModel for WorkItemPriorityWorkItemTypeTab
 */
class WorkItemPriorityWorkItemTypeTab extends GenericListSearchTab {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Parent = parent;

        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    // #endregion Constructor

    // #region Properties

    // Bao object to access session objects
    Bao = Bao;

    /**
     * Controller Url 
     */
    ControllerUrl = "WorkItemPriorityWorkItemTypeTab";

    /**
     * Parent of Tab
     */
    Parent: WorkItemPriority | WorkItemType;

    // #endregion Properties

    // #region Public Methods

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    CustomFilter = (): Models.HashObject[] => {
        let customFilterHashObject: Models.HashObject[] = [];
        return customFilterHashObject;
    }

    /**
     * Checks if the view model has been set correctly
     * @returns JqueryPromise<boolean>
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        return def.promise();
    }

    /**
     * Returns name of search type
     * @returns Name of search type
     */
    SearchType() {
        if (this.Parent.ClientRoute() == WorkItemRelationTabNames.WORK_ITEM_TYPE) {
            return WorkItemRelationTabNames.WORK_ITEM_PRIORITY;
        }
        else {
            return WorkItemRelationTabNames.WORK_ITEM_TYPE;
        }
    }


    /**
    * Check if Parent is WorkItemType
    * @returns true or false
    */
    IsParentWorkItemType = (): boolean => {
        return this.Parent.ClientRoute() == WorkItemRelationTabNames.WORK_ITEM_TYPE;
    }

    /**
     * Check if Parent is WorkItemPriority
     * @returns true or false
     */
    IsParentWorkItemPriority = (): boolean => {
        return this.Parent.ClientRoute() == WorkItemRelationTabNames.WORK_ITEM_PRIORITY;
    }

    /**
     * Override init method to not override title set by parent Module
     * @returns JQuery Promise
     */
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);

        return Bao.post(this.UrlInit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.InitResponse) => {
            this.Models(result.Models);
            this.TotalRows(result.TotalRows);
            this.PermissionAdd = result.Definition.PermissionAdd;
            this.PermissionEdit = result.Definition.PermissionEdit;
            this.PermissionRemove = result.Definition.PermissionRemove;
            this.BindingToolbar.formName = result.Definition.FormName;
            this.BindingToolbar.applicationId = result.Definition.ApplicationId;
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    // #endregion Public Methods

}
export default WorkItemPriorityWorkItemTypeTab;